import List from "./List";
import New from "./New";

export default {
  List,
  New
};
